import { render, staticRenderFns } from "./FeedItemReminder.vue?vue&type=template&id=4f233600&scoped=true&"
import script from "./FeedItemReminder.vue?vue&type=script&lang=js&"
export * from "./FeedItemReminder.vue?vue&type=script&lang=js&"
import style0 from "./FeedItemReminder.vue?vue&type=style&index=0&id=4f233600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f233600",
  null
  
)

export default component.exports